<template>
    <div class="arrow-comp" v-if="(showInMobile || !isMobileSize) && show">
        <i
            class="iconfont icon-arrow-up left"
            :class="{ disabled: disabled.prev }"
            @click="prev"
        ></i>
        <i
            class="iconfont icon-arrow-up right"
            :class="{ disabled: disabled.next }"
            @click="next"
        ></i>
    </div>
</template>

<script>
export default {
    emits: ['prev', 'next'],
    computed: {
        isMobileSize() {
            return this.platform.isMobile;
        }
    },
    props: {
        show: {
            type: Boolean,
            default: false
        },
        disabled: {
            type: Object,
            default: () => {
                return {
                    prev: false,
                    next: false
                };
            }
        },
        showInMobile: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        prev() {
            if (!this.disabled.prev) {
                this.$emit('prev');
            }
        },
        next() {
            if (!this.disabled.next) {
                this.$emit('next');
            }
        }
    }
};
</script>

<style lang="scss">
.arrow-comp {
    flex-shrink: 0;
    width: 98px;
    display: flex;
    flex-direction: row;
    align-content: flex-start;
    align-items: center;
    justify-content: space-between;
    .left {
        transform: translateX(3px) rotate(-90deg);
    }
    .right {
        transform: translateX(-10px) rotate(90deg);
    }
    .iconfont {
        color: #191919;
        font-size: 22px;
        cursor: pointer;
        width: 22px;
        height: 22px;
        &.disabled {
            color: #dadada;
            cursor: not-allowed;
        }
    }
}
</style>
